
export default function Privacy() {
  return (
    <div>
      <h1>Privacy</h1>
      <p>For the Meter Man website we don't need to store any inofrmation, however we do have adverts on the site, so there will be a handful of Google cookies to ensure you get relevant ads.</p>
    </div>
  );
}